import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Grid} from 'semantic-ui-react';
import {FilePond, registerPlugin} from 'react-filepond';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import {maxSizeEachFileInMegaBytes, maxSizeAllFilesInMegaBytes} from '../../../../../common/constants/ftr';
import {Actions} from '../../../../../common/actions';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
import 'filepond/dist/filepond.min.css';
import './attachments.scss';
registerPlugin(
  FilePondPluginFileValidateSize,
  FilePondPluginImagePreview,
);

const maxSizeEachFile = `${maxSizeEachFileInMegaBytes}MB`;
const maxSizeAllFiles = `${maxSizeAllFilesInMegaBytes}MB`;

class AttachmentsList extends Component {
  saveDowloadedData(data, filename) {
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.style = 'display: none';
    const blob = new Blob([data], {'type': 'octet/stream'});
    const url = window.URL.createObjectURL(blob);

    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  }

  onDownloadFile(position) {
    const {attachments} = this.props;
    const fileInBase64 = attachments[position].file;
    const filename = attachments[position].name;

    const pdfs = atob(fileInBase64);
    const len = pdfs.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = pdfs.charCodeAt(i);
    }
    this.saveDowloadedData(bytes.buffer, filename);
  }

  renderImagePreview(position) {
    const {attachments} = this.props;
    const mimetype = attachments[position].mimetype;

    if (mimetype.includes('image')) {
      const file = attachments[position].file;
      return (
        <img
          className='image'
          alt='preview imagen'
          src={`data:image/jpeg;base64, ${file}`}
        />
      );
    }
    return null;
  }

  renderFiles() {
    const {attachments} = this.props;
    if (!attachments.length) {
      return (
        <Grid.Row>
          <Grid.Column textAlign='center'>
            {' '}
            No hay archivos adjuntos
          </Grid.Column>
        </Grid.Row>
      );
    }

    return attachments.map((fileData, index) => {
      return (
        <Grid.Row key={index}>
          <Grid.Column width={2} textAlign='right'>
            {this.renderImagePreview(index)}
          </Grid.Column>
          <Grid.Column width={10} textAlign='left'>
            <span className='link' onClick={() => this.onDownloadFile(index)}>
              {fileData.name}
            </span>
          </Grid.Column>
        </Grid.Row>
      );
    });
  }

  chooseOrSeeFiles() {
    const {isDisplayMode, attachments} = this.props;
    if (isDisplayMode) {
      return <Grid textAlign='left'>{this.renderFiles()}</Grid>;
    }

    return (
      <FilePond
        allowMultiple={true}
        files={attachments}
        disabled={isDisplayMode}
        labelIdle='Arrastra y suelta tus archivos o <span class="filepond--label-action">Navegador</span>'
        onupdatefiles={(fileItems) => {
          const files = fileItems.map((fileItem) => fileItem.file);
          this.props.setAttachments(files);
        }}
        maxFileSize={maxSizeEachFile}
        labelMaxFileSizeExceeded='Archivo demasiado largo'
        labelMaxFileSize={`El tamaño máximo de archivo es ${maxSizeEachFile}`}
        maxTotalFileSize={maxSizeAllFiles}
        labelMaxTotalFileSizeExceeded='Tamaño total máximo excedido'
        labelMaxTotalFileSize={`El tamaño máximo total de los archivo es ${maxSizeAllFiles}`}
      />
    );
  }

  render() {
    return (
      <Card fluid raised className='attachments-tab'>
        {this.chooseOrSeeFiles()}
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'attachments': state.templateFTR.attachments,
  };
};

const {
  setAttachments,
} = Actions;

export default connect(mapStateToProps, {
  setAttachments,
})(AttachmentsList);
